import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { IconOpen, IconClose } from "./Icons";
import "./style.scss";

const DATATYPE_OBJECT = "object";

export function NativeDropdown(props) {
    const [selected, setSelection] = useState(null);
    const [allOptions, setAllOptions] = useState([]);
    const wrapRef = useRef(null);

    function setSelectionFromList(list, optionID) {
        const option = list.find((option) => option.optionID === optionID);
        if (isValid(option)) {
            setSelection(option);
            return option;
        }
    }

    function setSelectionByValue(list, value) {
        const option = list.find((option) => option.value === value);
        if (isValid(option)) {
            setSelection(option);
            return option;
        }
    }

    function isValid(value) {
        return value != undefined && value != null;
    }

    function makeOptionList(optionsList) {
        return optionsList.map((option, optionID) => {
            if (typeof option === DATATYPE_OBJECT) {
                return { ...option, optionID };
            } else {
                return { value: option, label: option, optionID };
            }
        });
    }

    useEffect(() => {
        const toSetOptions = makeOptionList(props.options);
        setAllOptions(toSetOptions);
        if (selected === null && isValid(props.defaultValue)) {
            setSelectionByValue(toSetOptions, props.defaultValue);
        } else if (isValid(props.value)) {
            setSelectionByValue(toSetOptions, props.value);
        }
    }, [props.options, props.value]);

    function setOption(value) {
        const optionID = parseInt(value, 10);
        const option = setSelectionFromList(allOptions, optionID);
        option && props.onChange(option);
    }

    function setOptionClassName({ value }) {
        return selected && value === selected.value ? "option-item selected" : "option-item";
    }

    function renderOptions() {
        return allOptions.map((option) => (
            <option key={option.optionID} className={setOptionClassName(option)} value={option.optionID} ariaLabel={option.ariaLabel}>
                {option.label}
            </option>
        ));
    }

    function getWrapperClassName() {
        return `react-native-dropdown ${props.className}`;
    }

    function renderOptionsList() {
        return (
            <select className="react-native-dropdown-options" onChange={(event) => setOption(event.target.value)} disabled={props.disabled}>
                <option value="default" disabled="true" selected="true">
                    {props.placeholder}
                </option>
                {renderOptions()}
            </select>
        );
    }

    return (
        <div className={getWrapperClassName()} ref={wrapRef} aria-label={props.ariaLabel}>
            {renderOptionsList()}
        </div>
    );
}

NativeDropdown.propTypes = {
    /**
     * Default selected option in list
     */
    defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * Placeholder message to be displayed on the dropdown
     */
    placeholder: PropTypes.string,
    /**
     * List of options to be displayed in dropdown
     */
    options: PropTypes.array.isRequired,
    /**
     * Callback function to  be executed when a new option is selected.
     */
    onChange: PropTypes.func.isRequired,
    /**
     * Currently selected option.
     */
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    /**
     * Boolean value specifying if dropdown is disabled
     */
    disabled: PropTypes.bool,
    /**
     * String value to be set as className
     */
    className: PropTypes.string,
};

NativeDropdown.defaultProps = {
    placeholder: "Please select.",
    className: "",
    value: undefined,
    defaultValue: undefined,
    iconClose: IconClose,
    iconOpen: IconOpen,
};
